import { render, staticRenderFns } from "./LawEventForm.vue?vue&type=template&id=4c7fdc2d&"
import script from "./LawEventForm.vue?vue&type=script&lang=js&"
export * from "./LawEventForm.vue?vue&type=script&lang=js&"
import style0 from "./LawEventForm.vue?vue&type=style&index=0&id=4c7fdc2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports